@if ((((isLoading || !isPlaying) && !hasModal) || (hasModal && !isModal)) && !youtubePosterUrl) {
  @if (!media?.previewMedia?.urlTwicPic || twicError) {
    <img #elementPreview
      [id]="customId"
      class="{{(hasModal && !isModal) ? 'is-modal-preview c__video-preview' : 'c__video-preview'}}"
      [alt]="hasAltText ? media?.previewMedia?.altText : ''"
      [attr.aria-hidden]="isAriaHidden ? true : undefined"
      [attr.role]="isAriaHidden ? 'presentation' : 'img'"
      [attr.data-twic-src-transform]="isFit ? 'contain' : 'cover-max'"
      [src]="media?.previewMedia?.url"
      [attr.data-type]="media?.mime?.split('/')[1]"
    />
  } @else {
    <img #elementPreview
      [id]="customId"
      class="c__video-preview twic {{(hasModal && !isModal) ? 'is-modal-preview' : ''}}"
      [alt]="hasAltText ? media?.previewMedia?.altText : ''"
      [attr.aria-hidden]="isAriaHidden ? true : undefined"
      [attr.role]="isAriaHidden ? 'presentation' : 'img'"
      [attr.data-src]="media?.previewMedia?.urlTwicPic"
      [attr.data-twic-src-transform]="isFit ? 'contain' : 'cover-max'"
      [attr.data-type]="media?.mime?.split('/')[1]"
    />
  }
}

@if (!isYoutube && mediaUrl) {
  @if ((hasModal && isModal) || !hasModal) {
    <video #element
      [id]="customId"
      (ended)="onVideoEnded()"
      [muted]="muted"
      (loadeddata)="videoReady($event)"
      [autoplay]="autoplayVideo"
      [loop]="loopVideo"
      [attr.data-type]="'video'"
      playsinline="true"
      [controls]="controlsVideo"
    >
      <source [src]="mediaUrl" />
    </video>
  }
}

<!-- Manage youtube video -->
@if (isYoutube) {
  @if (youtubePosterUrl && (!media?.previewMedia?.url && !media?.previewMedia?.urlTwicPic) && !isPlaying) {
    <img class="c__youtube-poster" [src]="youtubePosterUrl" alt="" />
  }
  @if ((hasModal && isModal) || !hasModal) {
    @if (isYoutubeReady) {
      <youtube-player #player
        [videoId]="mediaUrl"
        (ready)="togglePlay()"
        (ended)="onVideoEnded()"
        (stateChange)="videoReady($event)"
        [showBeforeIframeApiLoads]="false"
        [id]="customId"
        disablePlaceholder="true"
        [height]="360"
        [width]="640"
      />
    }
  }
}
